import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../style/pages/ScanRegistrationSelectionPage.module.css';

const ScanRegistrationSelectionPage = () => {
    const navigate = useNavigate();

    // Extract qrToken from URL
    const params = new URLSearchParams(window.location.search);
    const qrToken = params.get('qrToken');

    const handleCreateAsset = () => {
        navigate(`/admin?page=add_scanned_asset&qrToken=${qrToken || ''}`);
    };

    const handleCreateLocation = () => {
        // LocationForm already handles checking for qrToken in URL
        navigate(`/admin?page=add_location&qrToken=${qrToken || ''}`);
    };

    return (
        <div className={styles.selectionContainer}>
            <div className={styles.selectionCard}>
                <h1 className={styles.title}>Register Scanned Item</h1>
                <p className={styles.subtitle}>
                    You scanned an unassigned QR code. What would you like to assign it to?
                </p>
                <div className={styles.buttonGroup}>
                    <button className={styles.selectionButton} onClick={handleCreateAsset}>
                        <i className="fa-solid fa-box"></i>
                        <span>Create Asset</span>
                    </button>
                    <button className={styles.selectionButton} onClick={handleCreateLocation}>
                        <i className="fa-solid fa-warehouse"></i>
                        <span>Create Container (Location)</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ScanRegistrationSelectionPage;
